/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import { useHistory } from 'react-router-dom';

import UsersView from './users-view';
import UsersHelper from '../../store/users/action';
import { AdminService } from '../../services/requests';
import {
  usersAdded,
  changeDataById,
  changeDataByRole,
} from '../../store/users';
import { combineDataToUniqueArray } from '../../services/functions';
import { Toast } from '../../ui-kit';

const UsersContainer = (props) => {
  const [activeTab, setActiveTab] = useState(Number(sessionStorage.getItem('activeTab')) || 0);

  const savedData = JSON.parse(sessionStorage.getItem(renderDataObjectName()));

  const [updateDataLoading, setUpdateDataLoading] = useState(false);
  const [applicantsPageNumber, setApplicantsPageNumber] = useState(2);
  const [representativesPageNumber, setRepresentativesPageNumber] = useState(2);
  const [freelancersPageNumber, setFreelancersPageNumber] = useState(2);
  const [recruitersPageNumber, setRecruitersPageNumber] = useState(2);
  const [directionStr, setDirectionStr] = useState(savedData?.direction || 'desc');
  const [locationKeys, setLocationKeys] = useState([]);
  const [category, setCategory] = useState(savedData?.category || '');

  function renderDataObjectName() {
    switch (activeTab) {
      case 0:
        return 'applicants';
      case 1:
        return 'representatives';
      case 2:
        return 'freelancers';
      case 3:
        return 'recruiters';
      default:
        return 'applicants';
    }
  };

  const refreshAction = () => {
    setApplicantsPageNumber(2);
    setRepresentativesPageNumber(2);
    setFreelancersPageNumber(2);
    setRecruitersPageNumber(2);
    setDirectionStr(props.users.roles[renderDataObjectName()]?.direction || directionStr || 'desc');
    setCategory(props.users.roles[renderDataObjectName()]?.category || category || '');
    props.getAllUsers();
  };

  const directionRenderStr = () => {
    if (directionStr === 'desc') {
      setDirectionStr('asc');
      return 'asc';
    }
    setDirectionStr('desc');
    return 'desc';
  };

  const deleteUser = async (uid) => {
    setUpdateDataLoading(true);
    try {
      const res = await AdminService.deleteUser(uid);      
      const roleKey = renderDataObjectName();
      const currentData = props.users.roles[roleKey]?.data || [];

      props.usersAdded({
        key: roleKey,
        data: currentData.filter(user => user.uid !== uid),
        last: props.users.roles[roleKey]?.last,
        direction: directionStr,
        category: category,
      });
      
      setUpdateDataLoading(false);
    } catch (res) {
      setUpdateDataLoading(false);
    }
  }
  
  const sortUsersListByDateOfCreation = async (role, direction, category) => {
    setUpdateDataLoading(true);
    setDirectionStr(direction || 'desc');
    if (activeTab === 0) {
      setApplicantsPageNumber(2);
    } else if (activeTab === 1) {
      setRepresentativesPageNumber(2);
    } else if (activeTab === 2) {
      setFreelancersPageNumber(2);
    } else if (activeTab === 3) {
      setRecruitersPageNumber(2);
    }
    try {
      const res = await AdminService.getUsersList(role.slice(0, role.length - 1), 1, direction, category);
      if (res) {
        sessionStorage.setItem(role, JSON.stringify({
          ...props.users.roles[role],
          ...res,
          direction,
          category,
        }));
        props.changeDataByRole({ key: `${role}`, data: { ...res, direction, category } });
        setUpdateDataLoading(false);
      }
    } catch (err) {
      setUpdateDataLoading(false);
    }
  };

  const handleOnDocumentBottom = async () => {
    if (!updateDataLoading && !props.users.loading) {
      if (activeTab === 0 && !props.users.roles.applicants.last) {
        setApplicantsPageNumber(applicantsPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getUsersList('applicant', applicantsPageNumber, directionStr || 'desc', category || '');
          if (res) {
            props.usersAdded({
              key: 'applicants',
              data: combineDataToUniqueArray(props.users.roles.applicants.data, res.data, 'uid'),
              last: res.last,
              direction: directionStr,
              category: category,
            });
            setUpdateDataLoading(false);
          }
        } catch (err) {
          setUpdateDataLoading(false);
        }
      }

      if (activeTab === 1 && !props.users.roles.representatives.last) {
        setRepresentativesPageNumber(representativesPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getUsersList('representative', representativesPageNumber, directionStr || 'desc', category || '');
          if (res) {
            props.usersAdded({
              key: 'representatives',
              data: combineDataToUniqueArray(props.users.roles.representatives.data, res.data, 'uid'),
              last: res.last,
              direction: directionStr,
              category: category,
            });
            setUpdateDataLoading(false);
          }
        } catch (err) {
          setUpdateDataLoading(false);
        }
      }

      if (activeTab === 2 && !props.users.roles.freelancers.last) {
        setFreelancersPageNumber(freelancersPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getUsersList('freelancer', freelancersPageNumber, directionStr || 'desc', category || '');
          if (res) {
            props.usersAdded({
              key: 'freelancers',
              data: combineDataToUniqueArray(props.users.roles.freelancers.data, res.data, 'uid'),
              last: res.last,
              direction: directionStr,
              category: category,
            });
            setUpdateDataLoading(false);
          }
        } catch (err) {
          setUpdateDataLoading(false);
        }
      }

      if (activeTab === 3 && !props.users.roles.recruiters.last) {
        setRecruitersPageNumber(recruitersPageNumber + 1);
        setUpdateDataLoading(true);
        try {
          const res = await AdminService.getUsersList('recruiter', recruitersPageNumber, directionStr || 'desc', category || '');
          if (res) {
            props.usersAdded({
              key: 'recruiters',
              data: combineDataToUniqueArray(props.users.roles.recruiters.data, res.data, 'uid'),
              last: res.last,
              direction: directionStr,
              category: category,
            });
            setUpdateDataLoading(false);
          }
        } catch (err) {
          setUpdateDataLoading(false);
        }
      }
    }
  };

  const giveOutFullVersion = async (userId, role) => {
    setUpdateDataLoading(true);
    try {
      const res = await AdminService.giveOutFullVersion({ userId });
      if (res) {
        props.changeDataById({
          key: `${role}s`,
          id: userId,
          data: res,
        });
        if (res.subscribe.status) {
          Toast('success', 'You have successfully issued a subscription to a user');
        } else {
          Toast('success', 'You have successfully unsubscribed a user');
        }
        setUpdateDataLoading(false);
      }
    } catch (err) {
      console.log(err);
      setUpdateDataLoading(false);
    }
  };

  useBottomScrollListener(handleOnDocumentBottom);

  const checkActiveButton = () => {
    switch (props.history.location.hash.replace('#', '')) {
      case 'applicants':
        setActiveTab(0);
        break;
      case 'representatives':
        setActiveTab(1);
        break;
      case 'freelancers':
        setActiveTab(2);
        break;
      case 'recruiters':
        setActiveTab(3);
        break;
      default:
        setActiveTab(0);
        break;
    }
  };

  const history = useHistory();
  useEffect(() => history.listen((location) => {
    if (history.action === 'POP') {
      if (locationKeys[1] === location.key) {
        setLocationKeys(([_, ...keys]) => keys);
        checkActiveButton();
      } else {
        setLocationKeys((keys) => [location.key, ...keys]);
        checkActiveButton();
      }
    }
  }), [locationKeys]);

  useEffect(() => {
    checkActiveButton();
    if (sessionStorage.getItem(renderDataObjectName())) {
      const savedData = JSON.parse(sessionStorage.getItem(renderDataObjectName()));
      sessionStorage.setItem(renderDataObjectName(), JSON.stringify({
        ...props.users.roles[renderDataObjectName()],
        ...savedData,
      }));
      props.changeDataByRole({ key: renderDataObjectName(), data: { ...savedData } });
    }
  }, []);

  useEffect(() => {
    const savedData = JSON.parse(sessionStorage.getItem(renderDataObjectName()))
    setCategory(savedData?.category || props.users.roles[renderDataObjectName()].category || '');
    setDirectionStr(savedData?.direction || props.users.roles[renderDataObjectName()].direction || 'desc');
    sessionStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  return (
    <UsersView
      users={props.users}
      history={props.history}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      refreshAction={refreshAction}
      directionStr={directionStr}
      category={category}
      setCategory={setCategory}
      updateDataLoading={updateDataLoading}
      giveOutFullVersion={giveOutFullVersion}
      renderDataObjectName={renderDataObjectName}
      sortUsersListByDateOfCreation={sortUsersListByDateOfCreation}
      directionRenderStr={directionRenderStr}
      deleteUser={deleteUser}
    />
  );
};

UsersContainer.propTypes = {
  history: PropTypes.object,
  users: PropTypes.object,
  getAllUsers: PropTypes.func,
  usersAdded: PropTypes.func,
  changeDataById: PropTypes.func,
  changeDataByRole: PropTypes.func,
};
UsersContainer.defaultProps = {
  users: {},
  history: {},
  getAllUsers: () => {},
  usersAdded: () => {},
  changeDataById: () => {},
  changeDataByRole: () => {},
};

const mapStateToProps = (store) => ({
  users: store.users,
});

const mapDispatchToProps = (dispatch) => ({
  getAllUsers: () => dispatch(UsersHelper.getAllUsers()),
  usersAdded: (payload) => dispatch(usersAdded(payload)),
  changeDataById: (payload) => dispatch(changeDataById(payload)),
  changeDataByRole: (payload) => dispatch(changeDataByRole(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UsersContainer);
